import { Pipe, PipeTransform, Injector, Type } from "@angular/core";

@Pipe({
  name: "dynamicPipe",
})
export class DynamicPipe implements PipeTransform {
  constructor(private injector: Injector) {}

  transform(value: any, pipeName: Type<any>, pipeArgs: any, apply?: boolean): any {
    if (apply === undefined) {
      apply = true;
    }

    if (!pipeName || !apply) {
      return value;
    }
    const injector = Injector.create({
      name: "DynamicPipe",
      parent: this.injector,
      providers: [{ provide: pipeName }],
    });
    const pipe = injector.get(pipeName);

    let result = value;

    try {
      result = pipe.transform(value, pipeArgs);
    } catch (err) {}

    return result;
  }
}
